import { memo } from "react";
import { BoletoHeaderText, ContractLoading } from "../../../styles/Boleto";

const ContractDate = ({ date, hasError }) => (
  <BoletoHeaderText>
    Vigência <strong>{hasError ? " - " : date ?? <ContractLoading />}</strong>
  </BoletoHeaderText>
);

export default memo(ContractDate);
